import { c as _c } from "react/compiler-runtime";
import { Field, FieldError, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, selectVariant, Spinner } from '@repo/ui/components';
import { cn, VariantProps } from '@repo/ui/lib/utils';
import { ComponentProps } from 'react';
import { ReadOnlyTooltip, useReadOnly } from '../../components/readonly.tsx';
import { useFieldContext } from '../../lib/form-context.ts';
const CUSTOMS_REQUIRED_OPTIONS = [{
  label: 'Not required',
  value: 'false'
}, {
  label: 'Required',
  value: 'true'
}];
export const FormCustomsRequiredSelect = t0 => {
  const $ = _c(27);
  const {
    "data-testid": dataTestId,
    isPending: t1,
    placeholder: t2,
    variant: t3
  } = t0;
  const isPending = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "" : t2;
  const variant = t3 === undefined ? "default" : t3;
  const field = useFieldContext();
  const isReadOnly = useReadOnly();
  if (isReadOnly) {
    let t4;
    if ($[0] !== field) {
      t4 = CUSTOMS_REQUIRED_OPTIONS.find(option => option.value === field.state.value)?.label ?? "-";
      $[0] = field;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    let t5;
    if ($[2] !== t4) {
      t5 = <ReadOnlyTooltip>{t4}</ReadOnlyTooltip>;
      $[2] = t4;
      $[3] = t5;
    } else {
      t5 = $[3];
    }
    return t5;
  }
  let t4;
  if ($[4] !== field) {
    t4 = val => val && field.handleChange(val);
    $[4] = field;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = field.state.value;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("flex w-full justify-between gap-2 p-0 text-base data-[size=default]:h-6");
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = dataTestId ?? "form-customs-required-select-trigger";
  let t8;
  if ($[7] !== placeholder) {
    t8 = <SelectValue placeholder={placeholder} data-sentry-element="SelectValue" data-sentry-source-file="form-customs-required-select.tsx" />;
    $[7] = placeholder;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== isPending) {
    t9 = isPending && <Spinner className="text-muted-foreground ml-auto size-4" />;
    $[9] = isPending;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t7 || $[12] !== t8 || $[13] !== t9 || $[14] !== variant) {
    t10 = <SelectTrigger className={t6} data-testid={t7} hideChevron={true} variant={variant} data-sentry-element="SelectTrigger" data-sentry-source-file="form-customs-required-select.tsx">{t8}{t9}</SelectTrigger>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = variant;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SelectContent data-sentry-element="SelectContent" data-sentry-source-file="form-customs-required-select.tsx">{CUSTOMS_REQUIRED_OPTIONS.map(_temp)}</SelectContent>;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== field.state.value || $[18] !== isPending || $[19] !== t10 || $[20] !== t4) {
    t12 = <div className="relative"><Select disabled={isPending} items={CUSTOMS_REQUIRED_OPTIONS} onValueChange={t4} value={t5} data-sentry-element="Select" data-sentry-source-file="form-customs-required-select.tsx">{t10}{t11}</Select></div>;
    $[17] = field.state.value;
    $[18] = isPending;
    $[19] = t10;
    $[20] = t4;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== field.state.meta.errors) {
    t13 = <FieldError errors={field.state.meta.errors} data-sentry-element="FieldError" data-sentry-source-file="form-customs-required-select.tsx" />;
    $[22] = field.state.meta.errors;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12 || $[25] !== t13) {
    t14 = <Field className="gap-1" data-sentry-element="Field" data-sentry-component="FormCustomsRequiredSelect" data-sentry-source-file="form-customs-required-select.tsx">{t12}{t13}</Field>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
};
function _temp(option_0) {
  return <SelectItem data-testid={`form-customs-required-select-option-${option_0.value}`} key={option_0.value} value={option_0.value}>{option_0.label}</SelectItem>;
}